// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"TemplateListSms_blockClick_3oiHr"};